import { Injectable } from "@angular/core";
import { RELACION_TEMPLATES_CALCES_PLAZOS_ME, RELACION_TEMPLATES_CALCES_PLAZOS_MN, RELACION_TEMPLATES_CALCES_PLAZOS_TOTAL, RELACION_TEMPLATES_ESTRES, RELACION_TEMPLATES_FEC_ME, RELACION_TEMPLATES_FEC_MN, RELACION_TEMPLATES_FEC_TOTAL, RELACION_TEMPLATES_GAP, RELACION_TEMPLATES_LIQUIDEZ_AJUSTADA, RELACION_TEMPLATES_PRUEBA_ACIDA, RELACION_TEMPLATES_VOLATILIDAD } from "./mapeo-templates";
import { table } from "./models.model";

@Injectable({
  providedIn: 'root'
})
export class TemplateLoaderService{
  obtenerConfiguracionGap(id: string): table {
    return RELACION_TEMPLATES_GAP[id] ?? 'No existe configuracion para esta institución'
  }
  obtenerConfiguracionRazones(id: string, perspectiva: string): table {
    switch(perspectiva){
      case 'acida':
        return RELACION_TEMPLATES_PRUEBA_ACIDA[id] ?? 'No existe configuracion para esta institución';
      case 'ajustada':
        return RELACION_TEMPLATES_LIQUIDEZ_AJUSTADA[id] ?? 'No existe configuracion para esta institución';
      case 'estres':
        return RELACION_TEMPLATES_ESTRES[id] ?? 'No existe configuracion para esta institución';
      default: 
        return null;
    }
  }
  obtenerConfiguracionVolatilidad(id: string): table {
    return RELACION_TEMPLATES_VOLATILIDAD[id] ?? 'No existe configuracion para esta institución'
  }
  obtenerConfiguracionCalcesPlazos(id: string, perspectiva: string): table {
    switch(perspectiva){
      case 'Total':
        return RELACION_TEMPLATES_CALCES_PLAZOS_TOTAL[id] ?? "No existe configuración para esta institución";
      case 'Nacional':
        return RELACION_TEMPLATES_CALCES_PLAZOS_MN[id] ?? "No existe configuración para esta institución";
      case 'Extranjera':
        return RELACION_TEMPLATES_CALCES_PLAZOS_ME[id] ?? "No existe configuración para esta institución";
      default: 
        return null;
        
    }
  }
  obtenerConfiguracionFEC(id: string, perspectiva: string){
    switch(perspectiva){
      case 'Total': 
        return RELACION_TEMPLATES_FEC_TOTAL[id] ?? "No existe configuración para esta institución";
      case 'Nacional': 
        return RELACION_TEMPLATES_FEC_MN[id] ?? "No existe configuración para esta institución";
      case 'Extranjera': 
        return RELACION_TEMPLATES_FEC_ME[id] ?? "No existe configuración para esta institución";
      default :
        return null;

    }
  }
}